import { render, staticRenderFns } from "./ArticleModule.vue?vue&type=template&id=ca41c950&"
import script from "./ArticleModule.vue?vue&type=script&lang=js&"
export * from "./ArticleModule.vue?vue&type=script&lang=js&"
import style0 from "./ArticleModule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports